import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { trackEvent } from '@/lib/metaPixel';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleGoogleCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      // Extract session_id from URL fragment
      const hash = location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        console.error('No session_id found in callback');
        navigate('/login');
        return;
      }

      const result = await handleGoogleCallback(sessionId);
      
      if (result.success) {
        // Fire CompleteRegistration only when this callback JUST created
        // a new account (role_selected=false is the freshly-created flag).
        if (result.user && result.user.role_selected === false) {
          trackEvent('CompleteRegistration', { method: 'google' });
        }
        // Navigate to dashboard with user data
        navigate('/dashboard', { state: { user: result.user } });
      } else {
        console.error('Google auth failed:', result.error);
        navigate('/login', { state: { error: result.error } });
      }
    };

    processCallback();
  }, [location, navigate, handleGoogleCallback]);

  return (
    <div className="min-h-screen bg-[#070d1c] flex items-center justify-center relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        <div className="absolute -top-32 -left-32 h-[420px] w-[420px] rounded-full bg-amber-400/10 blur-3xl" />
        <div className="absolute top-1/3 -right-40 h-[520px] w-[520px] rounded-full bg-sky-500/15 blur-3xl" />
      </div>
      <div className="relative text-center">
        <img
          src="/logo.png"
          alt="PROP VEIW"
          className="w-24 h-24 mx-auto object-contain rounded-2xl bg-white/95 p-2 ring-1 ring-amber-300/40 shadow-2xl mb-6"
        />
        <div className="spinner mx-auto mb-4" />
        <p className="text-slate-300 font-medium">Completing sign in…</p>
      </div>
    </div>
  );
}
